import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import avatar3 from "../../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../../assets/images/users/avatar-4.jpg";
import { withTranslation } from "react-i18next";

const NotificationDropdown = (props) => {
  const [menu, setMenu] = useState(false);
  
  // ✅ Get notification count from props (default: 0)
  const notificationCount = props.notificationCount || 0;
  const hasNotifications = notificationCount > 0;

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="ri-notification-3-line" style={{ color: "black" }} />
          
          {/* ✅ Only show dot/badge when there are notifications */}
          {hasNotifications && (
            <span className="noti-dot">
              {/* Optional: Show count if > 1, otherwise just dot */}
              {notificationCount > 1 && notificationCount < 10 && (
                <span className="badge-count">{notificationCount}</span>
              )}
            </span>
          )}
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0 text-dark">
                  {props.t("Notifications")}{" "}
                  {/* ✅ Show count in dropdown header too */}
                  {hasNotifications && (
                    <span className="badge bg-primary rounded-pill ms-1">
                      {notificationCount}
                    </span>
                  )}
                </h6>
              </Col>
            </Row>
          </div>
          
          {/* ✅ Show empty state when no notifications */}
          {!hasNotifications ? (
            <div className="p-3 text-center text-muted">
              <i className="ri-notification-off-line font-size-24 mb-2"></i>
              <p className="mb-0 small">No new notifications</p>
            </div>
          ) : (
            /* Your notification list goes here */
            <>
              {/* Example notification items (uncomment and customize) */}
              {/* <Link to="" className="text-reset notification-item d-block p-3">
                <div className="d-flex">
                  <div className="flex-shrink-0 me-3">
                    <div className="avatar-xs">
                      <span className="avatar-title bg-primary rounded-circle font-size-16">
                        <i className="ri-shopping-cart-line"></i>
                      </span>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mb-1">Your order is placed</h6>
                    <div className="font-size-12 text-muted">
                      <p className="mb-1">If several languages coalesce the grammar</p>
                      <p className="mb-0">
                        <i className="mdi mdi-clock-outline"></i> 3 min ago
                      </p>
                    </div>
                  </div>
                </div>
              </Link> */}
            </>
          )}
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

NotificationDropdown.propTypes = {
  t: PropTypes.any,
  // ✅ Add prop for notification count
  notificationCount: PropTypes.number,
};

NotificationDropdown.defaultProps = {
  notificationCount: 0,
};

export default withTranslation()(NotificationDropdown);